import { Navigate, useParams } from "react-router-dom";
import { AlertTriangle, Wrench, LayoutGrid } from "lucide-react";
import { PageHero, useTitle } from "../components/PageHero";
import { Reveal, Tag } from "../components/Reveal";
import { PrimaryBtn } from "../components/ui";
import { CTABand } from "../components/CTABand";
import { INDUSTRIES } from "../data/industries";

const Block = ({ icon: Icon, title, items, testid }) => (
  <Reveal className="h-full">
    <div className="h-full border border-seam bg-iron p-7" data-testid={testid}>
      <Icon size={24} className="text-spark" />
      <h3 className="mt-4 font-display text-xl font-bold uppercase tracking-wide text-frost">{title}</h3>
      <ul className="mt-4 space-y-2.5">
        {items.map((it) => (
          <li key={it} className="flex items-start gap-2 text-sm leading-relaxed text-cadmium">
            <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rotate-45 bg-spark" /> {it}
          </li>
        ))}
      </ul>
    </div>
  </Reveal>
);

export default function IndustryDetail() {
  const { slug } = useParams();
  const ind = INDUSTRIES.find((x) => x.slug === slug);
  useTitle(ind ? `${ind.name} Industry Solutions | SABAKT Saudi Arabia` : "SABAKT");
  if (!ind) return <Navigate to="/industries" replace />;

  return (
    <main>
      <PageHero image={ind.image} eyebrow={`Industry · ${ind.name} · Saudi Arabia`} testid="industry-detail-hero"
        title={`${ind.name}: Fabrication, Wear Protection & Repair.`} accent={`${ind.name}:`}>
        <div className="mt-8">
          <PrimaryBtn to="/rfq" testid="industry-rfq-btn">Request an RFQ for {ind.name}</PrimaryBtn>
        </div>
      </PageHero>
      <section className="py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
          <Reveal>
            <Tag>Why SABAKT for {ind.name}</Tag>
            <p className="mt-4 max-w-3xl text-lg leading-relaxed text-frost/90">
              We approach {ind.name.toLowerCase()} work the same way we approach everything: understand the operating conditions, identify the failure mechanism, then fabricate, protect or rebuild against it — with Saudi-based execution and maintenance-window turnaround.
            </p>
          </Reveal>
          <div className="mt-12 grid gap-6 md:grid-cols-3">
            <Block icon={AlertTriangle} title="Operational Challenges" items={ind.challenges} testid="industry-challenges" />
            <Block icon={Wrench} title="SABAKT Solutions" items={ind.solutions} testid="industry-solutions" />
            <Block icon={LayoutGrid} title="Typical Applications" items={ind.applications} testid="industry-applications" />
          </div>
        </div>
      </section>
      <CTABand title={`Have a ${ind.name} Requirement?`} />
    </main>
  );
}
